/* lkp2-5.js - Lush Keepsake personaliser v2, part 5 of 16 (readable source: build/src/lkp2.js; split by build/minify.py) */
(function(){'use strict';var K=window.__lkp2k=window.__lkp2k||{};
var D=K.D,DASH=K.DASH,EN=K.EN,SEP_RE=K.SEP_RE,POUND_FMT=K.POUND_FMT,EMAIL=K.EMAIL,BLANK_DEFAULT=K.BLANK_DEFAULT,NUM_WORDS=K.NUM_WORDS,SWATCH=K.SWATCH,INK_DARK=K.INK_DARK,INK_LIGHT=K.INK_LIGHT,CAP=K.CAP,esc=K.esc,h=K.h,clamp=K.clamp,clone=K.clone,lc=K.lc,isObj=K.isObj,merge=K.merge,firstInt=K.firstInt,money=K.money,hash=K.hash,debounce=K.debounce,cleanLabel=K.cleanLabel,fontByN=K.fontByN,swatchFor=K.swatchFor,inkFor=K.inkFor,CFG=K.CFG,loadConfig=K.loadConfig,IMG=K.IMG,loadImg=K.loadImg,ART_INK=K.ART_INK,ARTTXT=K.ARTTXT,artBaseUrl=K.artBaseUrl,artText=K.artText,artRaster=K.artRaster,MOTIF=K.MOTIF,motifImg=K.motifImg,MAPS=K.MAPS,mapNorm=K.mapNorm,mapDist=K.mapDist,mapJson=K.mapJson,mapFind=K.mapFind,mapPlace=K.mapPlace,ICONIMG=K.ICONIMG,iconSvg=K.iconSvg,iconImg=K.iconImg,FONTREADY=K.FONTREADY,fontReady=K.fontReady,QR=K.QR,loadQR=K.loadQR,cleanRegion=K.cleanRegion,LEGACY=K.LEGACY,fallbackConfig=K.fallbackConfig,lineFields=K.lineFields,P=K.P,MORSE=K.MORSE,pathPts=K.pathPts,polyLen=K.polyLen,visRun=K.visRun,drawPathText=K.drawPathText,toMorse=K.toMorse,subMax=K.subMax,subKey=K.subKey,propKey=K.propKey,faceKey=K.faceKey,textKey=K.textKey,optText=K.optText,propVal=K.propVal,fmtDate=K.fmtDate,fmtTime=K.fmtTime,drawPlaceholder=K.drawPlaceholder,drawClock=K.drawClock,drawCalendar=K.drawCalendar,drawSpotify=K.drawSpotify,drawQR=K.drawQR,NOISE=K.NOISE,noisePattern=K.noisePattern,autoTone=K.autoTone,shade=K.shade,drawPlate=K.drawPlate,residual=K.residual,METAL=K.METAL;
P.prototype.countInfo = function () {
var c = this.cfg.count; if (!c) return null;
var all = this.allFaces(), ids = c.faces || all.map(function (f) { return f.id; });
var counted = all.filter(function (f) { return ids.indexOf(f.id) >= 0 || ids.indexOf(f._base) >= 0; });
var opt = null;
if (c.option) { if (this.optIndex[lc(c.option)] != null) opt = c.option; }
else (this.product.options || []).forEach(function (o) { if (!opt && /side|engrav/i.test(o)) opt = o; });
var v = opt ? this.optVal(opt) : null, n = null;
if (opt && isObj(c.values)) Object.keys(c.values).forEach(function (k) { if (lc(k) === lc(v)) n = c.values[k]; });
if (opt && n == null) n = firstInt(v);
if (n != null) n = clamp(n, 0, counted.length);
var open = n == null;
var req = c.required || (c['default'] && c['default'][0]) || (counted[0] && counted[0].id);
if (!counted.some(function (f) { return f.id === req; })) req = counted[0] && counted[0].id;
return { counted: counted, n: n, open: open, req: req, option: opt, pick: !open && c.pick === true, min: c.min || 1, max: c.max || counted.length };
};
P.prototype.isOptional = function (f) {
if (f.optional) return true;
var ci = this.countInfo();
return !!(ci && ci.open && f.id !== ci.req && ci.counted.some(function (x) { return x.id === f.id; }));
};
P.prototype.units = function (n) {
var pl = this.cfg.unit || (this.cfg.count && this.cfg.count.noun) || 'sides';
var sg = /halves$/.test(pl) ? pl.replace(/halves$/, 'half') : /ies$/.test(pl) ? pl.replace(/ies$/, 'y') : pl.replace(/s$/, '');
return n === 1 ? sg : pl;
};
P.prototype.countKey = function () {
var u = this.units(2); if (/engrav/.test(u)) u = 'areas';
return u.charAt(0).toUpperCase() + u.slice(1) + ' to ' + this.verb().act;
};
P.prototype.verb = function () {
var p = this.choices ? 'choices' : (this.cfg.process || 'engraved');
var V = {
engraved: { head: 'Add your engraving', yes: 'Yes, engrave it', yesSub: 'See it on the real piece', no: 'No, send it blank', noSub: 'No engraving', prop: 'Engraving', blankVal: 'No engraving (sent blank)', inc: 'engraving included', none: 'no engraving', sum: 'We will engrave', made: 'engraving', exact: 'I have checked the spelling, dates and layout. We engrave exactly what you type.', add: 'please add your engraving', note: 'Add a note for the engraver (optional)', act: 'engrave' },
printed: { head: 'Add your wording', yes: 'Yes, personalise it', yesSub: 'See it on the real piece', no: 'No, leave it plain', noSub: 'Not personalised', prop: 'Printing', blankVal: 'Not personalised', inc: 'personalisation included', none: 'not personalised', sum: 'We will print', made: 'printing', exact: 'I have checked the spelling, dates and layout. We print exactly what you type.', add: 'please add your wording', note: 'Add a note for us (optional)', act: 'print' },
raised: { head: 'Add your wording', yes: 'Yes, personalise it', yesSub: 'See it on the real piece', no: 'No, leave it plain', noSub: 'Not personalised', prop: 'Raised lettering', blankVal: 'Not personalised', inc: 'personalisation included', none: 'not personalised', sum: 'We will make', made: 'making', exact: 'I have checked the spelling, dates and layout. We make exactly what you type.', add: 'please add your wording', note: 'Add a note for us (optional)', act: 'make' },
choices: { head: 'Make it yours', yes: '', yesSub: '', no: '', noSub: '', prop: '', blankVal: '', inc: '', none: '', sum: 'Your choices', made: 'it is made', exact: 'I have checked my choices.', add: 'please make your choice', note: 'Add a note (optional)', act: 'make' }
};
return V[p] || V.engraved;
};
P.prototype.priceCount = function () {
var me = this, ci = this.countInfo(), faces = this.faces().filter(function (f) { return me.drawable(f); });
var ids = ci ? ci.counted.map(function (f) { return f.id; }) : [];
var other = faces.filter(function (f) { return ids.indexOf(f.id) < 0 && !me.isOptional(f); }).length;
if (!ci) return other;
if (ci.n != null) return ci.n + other;
return faces.filter(function (f) { return ids.indexOf(f.id) >= 0 && !me.isOptional(f); }).length + other;
};
P.prototype.faces = function () {
if (this.finishOnly) return [];
if (!this.choices && (this.isBlank() || !this.st.engrave)) return [];
var all = this.allFaces(), ci = this.countInfo(), me = this;
if (!ci) return all;
var countedIds = ci.counted.map(function (f) { return f.id; });
var keep;
if (ci.pick) {
if (!this.st.picked) this.st.picked = (this.cfg.count['default'] || countedIds).filter(function (id) { return countedIds.indexOf(id) >= 0; }).slice(0, ci.n || ((this.cfg.count['default'] || []).length || 1));
var lim = ci.n || ci.max;
this.st.picked = this.st.picked.filter(function (id) { return countedIds.indexOf(id) >= 0; });
if (ci.n) {
while (this.st.picked.length > lim) this.st.picked.pop();
countedIds.forEach(function (id) { if (me.st.picked.length < lim && me.st.picked.indexOf(id) < 0) me.st.picked.push(id); });
}
keep = this.st.picked;
} else keep = countedIds.slice(0, ci.n == null ? countedIds.length : ci.n);
return all.filter(function (f) { return countedIds.indexOf(f.id) < 0 || keep.indexOf(f.id) >= 0; });
};
P.prototype.face = function (id) { var r = null; this.allFaces().forEach(function (f) { if (f.id === id) r = f; }); return r; };
P.prototype.modeOf = function (f) { if (!f.modes) return null; var m = this.st.mode[f.id], r = f.modes[0]; f.modes.forEach(function (x) { if (x.id === m) r = x; }); return r; };
P.prototype.fieldsOf = function (f) {
var m = this.modeOf(f), list = (m ? m.fields : f.fields) || [];
return list.map(function (x, i) { var y = clone(x); y.id = y.id || (y.type === 'text' ? 'l' + (i + 1) : y.type); return y; });
};
P.prototype.libOptions = function (fd) {
if (typeof fd.options === 'string' && fd.options.charAt(0) === '@') return D.LIBS[fd.options.slice(1)] || [];
return fd.options || [];
};
P.prototype.selOption = function (f, fd) {
var v = this.val(f, fd.id), opts = this.libOptions(fd), r = null;
opts.forEach(function (o) { if (o.v === v) r = o; });
return r;
};
P.prototype.vals = function (f) {
var id = f.id;
if (f.sameAs && this.st.same[id]) id = f.sameAs;
if (!this.st.vals[id]) this.st.vals[id] = {};
return this.st.vals[id];
};
P.prototype.val = function (f, k) { return this.vals(f)[k]; };
P.prototype.fontOf = function (f) {
if (this.cfg.font === 'global') return this.st.gfont || this.cfg.fontDefault || 1;
var v = this.val(f, 'font'); if (v) return v;
var fd = null; this.fieldsOf(f).forEach(function (x) { if (x.type === 'font') fd = x; });
if (fd && typeof fd['default'] === 'string') { var g = this.face(fd['default']); if (g && g.id !== f.id) return this.fontOf(g); }
return (fd && fd['default']) || this.cfg.fontDefault || 1;
};
P.prototype.mediaUrl = function (ref) {
var p = this.product, m = null;
if (/^https?:|^\/\//.test(ref)) return ref.indexOf('//') === 0 ? 'https:' + ref : ref;
var mm = /^media:(\d+)$/.exec(ref); if (mm) m = p.media[parseInt(mm[1], 10)];
var mi = /^media-id:(\d+)$/.exec(ref); if (mi) p.media.forEach(function (x) { if (String(x.id) === mi[1]) m = x; });
if (!m) m = p.media[0];
return m ? m.src : null;
};
P.prototype.artOf = function (f) {
var a = f && f.art; if (!a) return null;
if (a.byOpt && a.byOpt.v) {
var v = lc(this.optByLabel(f, a.byOpt.o)), vs = a.byOpt.v, hit = null;
if (v) { Object.keys(vs).forEach(function (k) { if (lc(k) === v) hit = vs[k]; }); if (!hit) Object.keys(vs).forEach(function (k) { if (!hit && v.indexOf(lc(k)) === 0) hit = vs[k]; }); }
a = hit ? hit : a;
}
if (a.mm) f.mm = a.mm; // the render's true zone size drives the legibility check
return a;
};
P.prototype.optByLabel = function (f, name) {
if (!name) return null;
if (this.optIndex[lc(name)] != null) return this.optVal(name);
var me = this, out = null;
[f].concat(this.allFaces()).forEach(function (g) {
if (out != null || !g) return;
var V = me.vals(g); me.fieldsOf(g).forEach(function (fd) { if (out == null && lc(cleanLabel(fd.label)) === lc(name) && V[fd.id] != null) out = V[fd.id]; });
});
return out;
};
P.prototype.stoneMonth = function (f) {
var me = this, M = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'], out = null;
[f].concat(this.allFaces()).forEach(function (g) {
if (out || !g) return;
var V = me.vals(g);
me.fieldsOf(g).forEach(function (fd) {
if (out || !/stone|birth|month/i.test((fd.label || '') + ' ' + fd.id + ' ' + (typeof fd.options === 'string' ? fd.options : ''))) return;
var w = String(V[fd.id] || '').split(/[\s-]/)[0]; M.forEach(function (m) { if (lc(m) === lc(w)) out = m; });
});
});
return out;
};
P.prototype.noteText = function (f, tpl) {
var me = this, V = this.vals(f), fl = this.fieldsOf(f);
return String(tpl).replace(/\{(\w+)\}/g, function (_, id) {
var v = V[id]; if (!v) fl.forEach(function (fd) { if (fd.id === id && !v) v = fd.placeholder; });
return v ? String(v).replace(/^e\.g\.\s*/i, '') : '';
}).replace(/[\s:&+,-]+$/, '').replace(/\s+(&|\+)\s*$/, '').replace(/\s{2,}/g, ' ').trim();
};
P.prototype.mainArt = function () { var r = null, me = this; this.cfg.faces.forEach(function (g) { if (!r && g.art) r = me.artOf(g); }); return r; };
P.prototype.artPh = function (a, colour, whole) {
var c = a.c || {}, key = null, keys = Object.keys(c);
keys.forEach(function (k) { if (k !== '*' && lc(k) === lc(colour || '')) key = k; });
var v = c[key || '*'] || c[keys[0]] || 'silver'; if (typeof v === 'string') v = [v];
var fin = v[0], d = ART_INK[fin] || ART_INK._, st = (window.LKP2ART || {}).stones, month = st && st.ids && st.ids.indexOf(a.id) >= 0 ? this.stoneMonth(this._artFace) : null;
var r = { isArt: true, art: a.id, fin: fin, month: month, solid: !!a.solid, src: 'art:' + a.id + '.' + fin + (month ? '.' + month : ''), asp: a.asp || 1.5, zone: clone(a.zone || { x: 50, y: 50, w: 54, h: 20 }),
keepOut: whole ? [] : (a.keepOut || []), layouts: whole ? null : (a.layouts || null), view: whole ? null : (a.view || null), hasZone: !whole, ink: v[1] || d[0], tone: v[2] || d[1],
soft: /walnut|wood|leather|passport|mag-bookmark|wallet/.test(fin + ' ' + a.id), missing: !key && !!colour && keys.length > 1 && !c['*'], idx: 0, count: 1, isFallback: false,
motifs: whole ? null : (a.motifs || null) };
r.whole = !!whole;
if (!r.soft && !/printed|raised/.test(this.cfg.process || '')) r.ink = r.tone === 'light' ? INK_LIGHT : INK_DARK._;
return r;
};
P.prototype.motifsOf = function (f, ph) {
var list = ph && ph.motifs, me = this, out = [];
if (!list || !list.length || this.choices && f.draw === false && !f.art) return out;
var V = this.vals(f), fields = this.fieldsOf(f);
list.forEach(function (m) {
if (m.when && Object.keys(m.when).some(function (k) { return lc(V[k]) !== lc(m.when[k]); })) return;
if (m.mode && (me.st.mode[f.id] || (f.modes && f.modes[0] && f.modes[0].id)) !== m.mode) return;
if (m.outline) {
var ids = m.fields || [m.field], places = [], none = !ids.some(function (q) { return V[q] && String(V[q]).trim(); });
ids.forEach(function (id, i) {
var t = V[id];
if (none && i === 0) fields.forEach(function (x) { if (x.id === id && x.placeholder) t = String(x.placeholder).replace(/^e\.g\.\s*/i, ''); });
if (t && String(t).trim()) places.push(String(t).trim());
});
var pins = m.markerField && V[m.markerField] ? String(V[m.markerField]).split(/[,;\n]/).filter(function (q) { return q.trim(); }).length : 0;
if (places.length) out.push({ outline: places.slice(0, 2), box: m.box, marker: m.marker || 'heart-pin', pins: pins, dots: !!m.dots, ex: none });
return;
}
var LS = m.layouts || (m.designSet && (window.LKP2DESIGNS || {})[m.designSet]);
if (LS) {
var dfd = null; fields.forEach(function (x) { if (x.id === m.field) dfd = x; });
var lay = V[m.field] && LS[V[m.field]], exd = false;
if (!lay) { var o0 = dfd && (me.libOptions(dfd) || [])[0]; lay = o0 && LS[o0.v]; exd = true; }
if (!lay) return;
ph.design = { lay: lay, box: m.box, tf: m.textFields || ['l1', 'l2'], ex: exd };
if (lay.motif) { var mb = lay.motifBox || [0.5, 0.5, 1, 1], B = m.box; out.push({ id: lay.motif, box: { x: B.x + (mb[0] - 0.5) * B.w, y: B.y + (mb[1] - 0.5) * B.h, w: mb[2] * B.w, h: mb[3] * B.h }, ex: exd }); }
return;
}
var map = m.map || {}, keys = Object.keys(map), v = V[m.field], id = null, ex = false, fd = null;
var pick = function (val) { var r = null; keys.forEach(function (k) { if (lc(k) === lc(val)) r = map[k]; }); if (!r) keys.forEach(function (k) { if (!r && lc(val).indexOf(lc(k)) === 0) r = map[k]; }); return r; };
fields.forEach(function (x) {
if (x.id === m.field) fd = x;
var so = !fd && x.type === 'select' ? me.selOption(f, x) : null;
if (so) (so.fields || []).forEach(function (sf) { if (sf.id === m.field && !fd) { fd = sf; v = V[x.id + '.' + sf.id]; } });
});
if (v != null && v !== '') id = pick(v);
else {
var o = fd && fd.type === 'select' ? (me.libOptions(fd) || [])[0] : null;
id = o ? pick(o.v) : null; ex = true;
}
if (id) out.push({ id: id, box: m.box, textBox: m.textBox, ex: ex });
});
return out;
};
})();